import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 12 12"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M11 3.587a1.5 1.5 0 0 0-.371-.989l-.069-.072-.585-.586a1.5 1.5 0 0 0-2.05-.068l-.071.068L7 2.793 5.854 1.647a.5.5 0 0 0-.66-.041l-.048.041-2 2a.5.5 0 0 0 .66.749l.047-.042L5.5 2.708l.793.793L2.56 7.233c-.331.33-.53.77-.558 1.237L2 8.587c0 .337.09.665.254.952l-.606.608a.5.5 0 0 0 .66.749l.046-.042.608-.607a1.91 1.91 0 0 0 2.222-.227l.085-.08 5.292-5.293a1.5 1.5 0 0 0 .437-.961zm-1 0a.5.5 0 0 1-.103.304l-.043.049L9 4.794 7.707 3.5l.853-.854a.5.5 0 0 1 .288-.142l.066-.005a.5.5 0 0 1 .305.104l.049.043.585.586a.5.5 0 0 1 .147.354"
    }, null, -1)
  ])))
}
export default { render: render }